<template>
  <div class="home">
    <HeroSection />
    <CTACards />
    <VisionMission />
    <OurWork />
    <Testimonials />
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'
import HeroSection from '@/components/HeroSection.vue'
import CTACards from '@/components/CTACards.vue'
import VisionMission from '@/components/VisionMission.vue'
import OurWork from '@/components/OurWork.vue'
import Testimonials from '@/components/Testimonials.vue'

@Options({
  components: {
    HeroSection,
    CTACards,
    VisionMission,
    OurWork,
    Testimonials
  }
})
export default class HomeView extends Vue {}
</script>
